import React from 'react';
import {MegaMenu, MegaMenuColumn, MegaMenuListColumn, MegaMenuSectionColumn} from './MegaMenu';
import { useTranslation, Link } from 'gatsby-plugin-react-i18next';

import { useAppState } from '@contexts/AppContext';


const FlexEZMegaMenu = ({ hasScrolled }) => {
	const {  setActiveSection } = useAppState();
	const { t } = useTranslation("megamenu");

	const LearnMore  = () => {
		return (<Link to="/flexez" className={`${ hasScrolled ? 'text-purple-800 hover:text-purple-400 transition-colors' 
		                                                      : 'text-purple-200 hover:text-purple-400 transition-colors'}`}>{t("navigation.learnmore")}</Link>);
	};

    const CustomerTestimonial = () => (
      <div className="px-2">
        <h3 className={`mb-3 text-lg font-bold ${hasScrolled ? 'text-purple-700' : 'text-white'}`}>
          {t("flexez.testimonial.title")}
        </h3>
        <div className={`rounded-lg p-3 ${hasScrolled ? 'bg-purple-50' : 'bg-purple-800'}`}>
          <div className={`mb-1 font-medium ${hasScrolled ? 'text-purple-700' : 'text-white'}`}>
            {t("flexez.testimonial.company")}
          </div>
          <Link
            to="/flexez/case-studies/alive-groupe"
            className={`text-sm hover:underline ${hasScrolled ? 'text-gray-600' : 'text-purple-200'}`}
            onClick={() => setActiveSection("flexez")}
          >
            {t("flexez.testimonial.quote")}
          </Link>
          <div className={`mt-2 text-xs ${hasScrolled ? 'text-gray-500' : 'text-purple-300'}`}>
            {t("flexez.testimonial.author")}
          </div>
          <Link
            to="/flexez/case-studies"
            className={`mt-3 inline-block text-xs font-semibold hover:underline ${hasScrolled ? 'text-purple-700' : 'text-purple-100'}`}
            onClick={() => setActiveSection("flexez")}
          >
            {t("flexez.testimonial.caseStudiesLink")}
          </Link>
        </div>
      </div>
    );
	const flexezData = {
	  solutions: [
		{
		  id: 'room-booking',
		  title: t("flexez.solutions.roombooking.title"),
		  description: t("flexez.solutions.roombooking.desc"),
		  uri: '/flexez/solutions/room-booking'
		},
		{
		  id: 'desk-booking',
		  title: t("flexez.solutions.deskbooking.title"),
		  description: t("flexez.solutions.deskbooking.desc"),
		  uri: '/flexez/solutions/desk-booking'
		},
		{
		  id: 'hybrid-attendance',
		  title: t("flexez.solutions.hybrid.title"),
		  description: t("flexez.solutions.hybrid.desc"),
		  uri: '/flexez/solutions/hybrid-attendance'
		},
		{
		  id: 'resource-analytics',
		  title: t("flexez.solutions.analytics.title"),
		  description: t("flexez.solutions.analytics.desc"),
		  uri: '/flexez/solutions/resource-analytics'
		},
		{
		  id: 'digital-signage',
		  title: t("flexez.solutions.signage.title"),
		  description: t("flexez.solutions.signage.desc"),
		  uri: '/flexez/solutions/digital-signage'
		},
		{
			id: "msteams",
			title: t("flexez.solutions.msteams.title"),
			description: t("flexez.solutions.msteams.desc"),
			uri: '/flexez/solutions/msteams'
		},
        {
            id: "onpremise",
            title: t("flexez.solutions.onpremise.title"),
            description: t("flexez.solutions.onpremise.desc"),
            uri: '/flexez/solutions/on-premise'
        },
        {
            id: "ai-meetings",
            title: t("flexez.solutions.aimeetings.title"),
            description: t("flexez.solutions.aimeetings.desc"),
            uri: '/flexez/solutions/ai-meetings'
        },
        {
            id: "service-attachments",
            title: t("flexez.solutions.serviceattachments.title"),
            description: t("flexez.solutions.serviceattachments.desc"),
            uri: '/flexez/solutions/service-attachments'
        }
	  ],
	  hardware: [
		{
		  id: 'eztablet-series',
		  title: t("flexez.hardware.eztab.title"),
		  description: t("flexez.hardware.eztab.desc"),
		  uri: '/flexez/hardware/eztablet-series'
		},
		{
		  id: 'occupancy-sensors',
		  title: t("flexez.hardware.sensor.title"),
		  description: t("flexez.hardware.sensor.desc"),
		  uri: '/flexez/hardware/occupancy-sensors'
		},
		{
		  id: 'partner-hardware',
		  title: t("flexez.hardware.partner.title"),
		  description: t("flexez.hardware.partner.desc"),
		  uri: '/flexez/hardware/partner-hardware'
		},
		{
		  id: 'epaper-displays',
		  title: t("flexez.hardware.epaper.title"),
		  description: t("flexez.hardware.epaper.desc"),
		  uri: '/flexez/hardware/epaper-displays'
		},
		{
		  id: 'iot-integration',
		  title: t("flexez.hardware.iot.title"),
		  description: t("flexez.hardware.iot.desc"),
		  uri: '/flexez/hardware/iot-integration'
		}
		],
	   services: [
		{
		  id: 'cloud-workspacemanagement',
		  title: t("flexez.services.cloud.title"),
		  description: t("flexez.services.cloud.desc"),
		  uri: '/flexez/services/cloud'
		  }
	  ],
	  industries: [
		{
		  id: 'corporate-workplaces',
		  title: t("flexez.industries.corporate.title"),
		  description: t("flexez.industries.corporate.desc"),
		  uri: '/flexez/industries/corporate-workplaces'
		},
		{
		  id: 'regulated-secure-environments',
		  title: t("flexez.industries.secure.title"),
		  description: t("flexez.industries.secure.desc"),
		  uri: '/flexez/industries/regulated-secure-environments'
		},
		{
		  id: 'coworking-spaces',
		  title: t("flexez.industries.coworking.title"),
		  description: t("flexez.industries.coworking.desc"),
		  uri: '/flexez/industries/coworking-spaces'
		},
		{
		  id: 'education',
		  title: t("flexez.industries.education.title"),
		  description: t("flexez.industries.education.desc"),
		  uri: '/flexez/industries/education'
		}
	  ]
	};




  return	(
<MegaMenu hasScrolled={hasScrolled} width={980} more={<LearnMore/>}>
		<MegaMenuListColumn 
		  title={t("flexez.menu.solutions")}
		  items={flexezData.solutions}
		  hasScrolled={hasScrolled}
		  onItemClick={(item) => {
			// logging
			setActiveSection("flexez");
		  }}
		/>
		<MegaMenuSectionColumn>
			<MegaMenuListColumn 
			  title={t("flexez.menu.hardware")}
			  items={flexezData.hardware}
			  hasScrolled={hasScrolled}
			  onItemClick={(item) => {
				// logging
				setActiveSection("flexez");
			  }}
			/>
			<MegaMenuListColumn 
			  title={t("flexez.menu.services")}
			  items={flexezData.services}
			  hasScrolled={hasScrolled}
			  onItemClick={(item) => {
				// logging
				setActiveSection("flexez");
			  }}
			/>
		</MegaMenuSectionColumn>
		<MegaMenuSectionColumn>
			<MegaMenuListColumn
			  title={t("flexez.menu.industries")}
			  items={flexezData.industries}
			  hasScrolled={hasScrolled}
			  onItemClick={() => setActiveSection("flexez")}
			/>
			<MegaMenuColumn>
			  <CustomerTestimonial />
			</MegaMenuColumn>
		</MegaMenuSectionColumn>
	  </MegaMenu>
	);
};

export default FlexEZMegaMenu;
